import { gql, useQuery } from "@apollo/client";
import { AsyncQueryStatus } from "../../models/AsyncActionStatus";
import { getErrors } from "../../utils/apolloError";
import { GetMyActiveOrgUsers } from "./__generated__/GetMyActiveOrgUsers";
import { ORG_USER_FIELDS } from "../fragments/OrgUser";
import { CORE_ORGANIZATION_FIELDS } from "../fragments/organization";
import { CORE_LICENCE_FIELDS } from "../fragments/Licence";
import { ORG_ROLE_FIELDS } from "../fragments/OrgRole";

export const GET_MY_ACTIVE_ORG_USERS = gql`
  ${ORG_USER_FIELDS}
  ${CORE_ORGANIZATION_FIELDS}
  ${CORE_LICENCE_FIELDS}
  ${ORG_ROLE_FIELDS}
  query GetMyActiveOrgUsers {
    myActiveOrgUsers {
      ...OrgUserFields
      licenceId
      licence {
        ...CoreLicenceFields
      }
      organization {
        ...CoreOrganizationFields
        activeLicences {
          ...CoreLicenceFields
          availableUserSlots
        }
        esriConfig {
          integrationTypeId
          webMapItemId
        }
        orgRoles {
          ...OrgRoleFields
        }
      }
    }
  }
`;

export function useGetMyActiveOrgUsers(skip = false) {
  const { loading, error, data } = useQuery<GetMyActiveOrgUsers>(GET_MY_ACTIVE_ORG_USERS, {
    errorPolicy: "all",
    fetchPolicy: "cache-and-network",
    skip,
  });

  return {
    data,
    status: {
      loading,
      errors: getErrors(error),
      successful: !error && data ? true : false,
    } as AsyncQueryStatus,
  };
}
